module.exports = __webpack_public_path__ + "static/img/notice-pic.b0cf3787.png";